import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    border-radius: 16px;
    padding: 32px;
    background-color: ${theme.v3.colors.neutral[100]};


    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 24px;
    }
    
    @media (max-width: ${theme.v3.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TitleAdapter = styled.div`
  display: flex;
  gap: 8px;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 32px 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin: 0 0 24px 0;
    }
  `}
`;

export const InfoDate = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 16px;
    border-radius: ${theme.v3.border.radius.md};
    border: 1px solid ${theme.v3.colors.neutral[90]};
    color: ${theme.v3.colors.neutral[10]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
  `};
`;

export const ChartContainer = styled.div`
  ${({ theme }) => css`
    height: 400px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      height: 300px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      height: 250px;
    }
  `}
`;

export const EmptyStateContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 100%;
    color: ${theme.v3.colors.neutral[40]};
  `}
`;

export const EmptyImage = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
`;

export const EmptyTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const EmptyDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[60]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;
